<template>
  <div style="overflow: hidden">
    <div v-transfer-dom>
      <popup v-model="show1">
        <popup-header
          left-text="取消"
          right-text="确定"
          title="请选择支行"
          :show-bottom-border="false"
          @on-click-left="show1 = false"
          @on-click-right="confirm"
        >
        </popup-header>
        <group gutter="0">
          <div class="flex vux-1px-b">
            <input
              class="searchInput flex1"
              v-model="name"
              placeholder="请输入支行名称"
            />
            <span class="searchButton" @click="search">搜索</span>
          </div>
          <picker :data="bankContactList" v-model="bankContactName"></picker>
        </group>
      </popup>
    </div>
  </div>
</template>

<script>
import { PopupHeader, Popup, Group, Picker } from "vux";
import { getContactsBankList } from "../../../api/bank";
export default {
  name: "bankList",
  components: {
    PopupHeader,
    Popup,
    Group,
    Picker
  },
  data() {
    return {
      show1: false,
      params: {
        bankContactName: "",
        bankContactNo: ""
      },
      param: {},
      name: "",
      bankContactList: [],
      bankContactName: [""]
    };
  },
  methods: {
    confirm() {
      this.show1 = false;
      this.params.bankContactName = this.bankContactName[0];
      for (let i = 0; i < this.bankContactList[0].length; i++) {
        if (
          this.bankContactList[0][i].bankContactName == this.bankContactName[0]
        ) {
          this.params.bankContactNo = this.bankContactList[0][i].bankContactNo;
        }
      }
      this.$emit("getContactBankInfo", this.params);
    },
    search() {
      getContactsBankList({ ...this.param, name: this.name })
        .then(res => {
          this.bankContactList = [];
          let bankContactList = [];
          for (let i = 0; i < res.length; i++) {
            res[i].key = res[i].bankContactName;
            res[i].value = res[i].bankContactName;
            res[i].name = res[i].bankContactName;
            bankContactList.push(res[i]);
          }
          this.bankContactList.push(bankContactList);
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getContactsBankList(params) {
      this.param = params;
      getContactsBankList(params)
        .then(res => {
          this.bankContactList = [];
          let bankContactList = [];
          for (let i = 0; i < res.length; i++) {
            res[i].key = res[i].bankContactName;
            res[i].value = res[i].bankContactName;
            res[i].name = res[i].bankContactName;
            bankContactList.push(res[i]);
          }
          this.bankContactList.push(bankContactList);
        })
        .catch(err => {
          this.$showError(err);
        });
    }
  }
};
</script>

<style scoped>
.flex {
  display: flex;
}

.flex1 {
  flex: 1;
}

.searchInput {
  font-size: 14px;
  border: 1px solid #e8e8e8;
  margin: 20px 0 20px 20px;
  border-radius: 10px;
  padding: 10px 20px;
  height: 40px;
}
.searchButton {
  margin: 20px 10px;
  padding: 10px 0;
  display: inline-block;
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
}
</style>
